// api.js
import axios from "axios";
import { store } from "../../store";
import { AuthAction } from "../../store/actions";

let isRefreshing = false;
let refreshSubscribers = [];

const subscribeTokenRefresh = (cb) => refreshSubscribers.push(cb);
const onRefreshed = (token) => {
  refreshSubscribers.forEach((cb) => cb(token));
  refreshSubscribers = [];
};

const api = axios.create({});

api.interceptors.request.use((config) => {
  const loggedOutOnce = localStorage.getItem("loggedOutOnce");

  if (!loggedOutOnce || loggedOutOnce === "no") {
    localStorage.setItem("loggedOutOnce", "yes");
    store?.dispatch(AuthAction.Logout());
  }
  const lsAuth = localStorage.getItem("authUser");

  const tokenFromStore = lsAuth || store.getState()?.auth?.user || null;
  const deviceId = localStorage.getItem("config_state_hash");

  config.headers = config.headers || {};
  if (tokenFromStore) {
    // If your backend expects Bearer, use: `Bearer ${tokenFromStore}`
    config.headers.authorization = tokenFromStore;
  }
  if (deviceId) {
    config.headers.config_state_hash = deviceId;
  }
  config.headers.requestedfrom = "web";
  return config;
});

// Call your saga, resolve with new token
const refreshAccessToken = () =>
  new Promise((resolve, reject) => {
    store.dispatch(
      AuthAction.refreshToken({
        cb: (res) => {
          const next = res?.data?.data?.AuthenticationResult?.AccessToken;
          if (res?.status === 200 && next) resolve(next);
          else reject(res);
        },
      }),
    );
  });

// Handle 401s
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error?.config || {};
    const res = error?.response;

    if (!res) return Promise.reject(error);

    const is401 = res.status === 401;
    const isRefreshCall = /\/auth\/refresh$/i.test(originalRequest?.url || "");
    const isProfileCall = /\/user\/profile\/?$/i.test(
      originalRequest?.url || "",
    );
    const inactiveProfileError =
      res?.data?.error === "User is not active or does not exist";

    if (is401 && isProfileCall && inactiveProfileError) {
      store?.dispatch(AuthAction.Logout());
      return Promise.reject(error);
    }

    if (is401 && !isRefreshCall && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        if (isRefreshing) {
          // wait for ongoing refresh
          return new Promise((resolve) => {
            subscribeTokenRefresh((token) => {
              originalRequest.headers = {
                ...(originalRequest.headers || {}),
                authorization: token,
              };
              resolve(api(originalRequest));
            });
          });
        }

        isRefreshing = true;
        const newToken = await refreshAccessToken();
        isRefreshing = false;

        api.defaults.headers.common.authorization = newToken;
        onRefreshed(newToken);

        originalRequest.headers = {
          ...(originalRequest.headers || {}),
          authorization: newToken,
        };
        return api(originalRequest);
      } catch (e) {
        isRefreshing = false;
        refreshSubscribers = [];
        // refresh failed → logout
        store?.dispatch(AuthAction.Logout());
        return Promise.reject(error);
      }
    }

    return Promise.reject(error);
  },
);

export default api;
